import { render } from "./SupplierList.vue?vue&type=template&id=d4a059b0&ts=true"
import script from "./SupplierList.vue?vue&type=script&lang=ts"
export * from "./SupplierList.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__